<template>
  <el-row>
    <el-form :model="addJoinWayForm"
             ref="addJoinWayRef"
             :rules="rules"
             @onSelectInfo="onSelectInfo"
             addAction="weChartCpCustom/updateJoinWay.action"
             editAction="weChartCpCustom/updateJoinWay.action"
             selectAction="weChartCpCustom/selectJoinWay.action"
             label-width="150px"
             style="width:50%"
             v-form>
      <el-form-item label="名称">
        <el-input :disabled="true" v-model="addJoinWayForm.chatName"></el-input>
      </el-form-item>
      <el-form-item label="是否自动新建群">
        <el-select v-model="addJoinWayForm.autoCreateRoom" placeholder="请选择">
          <el-option label="否" :value="0"></el-option>
          <el-option label="是" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="addJoinWayForm.regionType" placeholder="请选择">
          <el-option label="全国" :value="1"></el-option>
          <el-option label="省级" :value="2"></el-option>
          <el-option label="市级" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="addJoinWayForm.status" placeholder="请选择">
          <el-option label="展示" :value="1"></el-option>
          <el-option label="不展示" :value="2"></el-option>
          <el-option label="已解散" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="头像" prop="chatImage">
        <el-upload
            multiple
            :limit="1"
            ref="imgLink"
            :http-request="onHttpRequest"
            accept="image/*"
            action="upload/uploadPic"
            v-model="addJoinWayForm.chatImage"
            :before-upload="beforeAvatarUpload"
            :data="{floder:'wx_cp_group'}"
            list-type="picture-card"
            :file-list="addJoinWayForm.chatImage">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>

      <el-form-item label="群二维码" prop="qrCode">
        <el-upload
                multiple
                :limit="1"
                ref="qrCodeImgLink"
                :http-request="onHttpRequest"
                accept="image/*"
                action="upload/uploadPic"
                v-model="addJoinWayForm.qrCode"
                :before-upload="beforeAvatarUpload"
                :data="{floder:'wx_cp_group'}"
                list-type="picture-card"
                :file-list="addJoinWayForm.qrCode">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>

      <el-form-item>

        <el-button type="primary">确定</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'
export default {
  name: 'addJoinWay',
  extends: BasicPager,
  components: {},
  data: function () {
    return {
      rules: {},
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      addJoinWayForm: {
        id: null,
        agentId: 1000004,
        chatName: null,
        regionType: null,
        status: null,
        chatImage: [],
        autoCreateRoom: null,
        qrCode: []

      }
    }
  },
  created () {
    this.addJoinWayForm.id = this.$route.query.id
  },
  methods: {
    onFilterParams: function (params) {
    },
    onSelectInfo: function (dataInfo) {
    },
    beforeAvatarUpload (file) {
      let _this = this
      var promise = new Promise(function (resolve, reject) {
        const isLt5M = file.size / 1024 / 1024 < 15
        if (!isLt5M) {
          _this.$message.error('上传图片大小不能超过 15MB!')
          reject(new Error('上传图片大小不能超过 15MB!'))
          return
        }

        if (_this.addJoinWayForm.chatImage.length >= 2) {
          _this.$message.error('最多只能上传1张!')
          reject(new Error('最多只能上传1张!'))
          return
        }
        resolve()
      })
      return promise
    }
  },
  filters: {}

}
</script>

<style scoped>

</style>
